module.exports = __webpack_public_path__ + "static/img/logo113.2b3e6b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo113.png
// module id = aB45
// module chunks = 1